import type { MutationKey, UseMutationOptions } from '@tanstack/react-query';
import { postAnalytics, type ZitchaCollectParams } from './zitcha.api';
import { OptionalMutationOptions, QueryApiOptions } from '../../types/types';

export const zitchaMutationKeys = {
  all: () => ['zitcha'] as MutationKey,
  analytics: () => [...zitchaMutationKeys.all(), 'analytics'] as MutationKey,
};

export const zitchaMutations = (apiOptions: QueryApiOptions) => ({
  postAnalytics: (
    options: OptionalMutationOptions<void, ZitchaCollectParams> = {}
  ): UseMutationOptions<void, Error, ZitchaCollectParams> => ({
    ...options,
    mutationKey: zitchaMutationKeys.analytics(),
    mutationFn: (payload: ZitchaCollectParams) => postAnalytics(apiOptions, payload),
  }),
});
